import { get, put } from 'axios'

const endpoint = '/users'
const defaultLimit = 15

const URL = fields => `${endpoint}?${transformFilterFields(fields)}`

const transformFilterFields = fields => {
  const assignedFields = { limit: defaultLimit, ...fields }
  return Object.keys(assignedFields)
    .filter(key => !!assignedFields[key])
    .map(key => `${key}=${encodeURIComponent(assignedFields[key])}`)
    .join('&')
}

export const searchUsers = fields => get(URL(fields)).then(res => res.data)

export const editUsers = data =>
  put(`${endpoint}/edit`, data)
    .then(res => res.data)
    // eslint-disable-next-line no-console
    .catch(e => console.log(e))

export default {
  searchUsers,
  editUsers,
}
